<!-- OBS Vi gör om "showroomet" med rask komponenter när dessa finns-->
<div class="menu">
    <ul>
        <li class="category">Sida</li>
        <li target="rask-page"><a href="javascript:;" (click)="scrollToView('top')">Topp</a></li>
        <li target="rask-page"><a routerLink="/components/example">Komponenter i formulär</a></li>
        <li class="category">Paneler</li>
        <li target="rask-page"><a href="javascript:;" (click)="scrollToView('raskpage')">page</a></li>
        <li target="rask-container-block"><a href="javascript:;" (click)="scrollToView('raskcontainerblock')">container
                block</a></li>
        <li target="rask-toggle-panel"><a href="javascript:;" (click)="scrollToView('rasktogglepanel')">toggle panel</a>
        </li>
        <li target="rask-collapsable"><a href="javascript:;" (click)="scrollToView('raskcollapsable')">collapsable
                panel</a></li>
        <li target="rask-message-panel"><a href="javascript:;" (click)="scrollToView('raskmessagepanel')">message
                panel</a></li>
        <li target="vertical-collapsable"><a href="javascript:;" (click)="scrollToView('verticalcollapsable')">vertical
                collapsable</a></li>
        <li target="rask-card"><a href="javascript:;" (click)="scrollToView('raskcard')">card</a></li>

        <li class="category">Layoutkomponenter</li>
        <li target="rask-header"><a href="javascript:;" (click)="scrollToView('raskheader')">header</a></li>
        <li target="rask-tabs"><a href="javascript:;" (click)="scrollToView('rasktabs')">tabs</a></li>
        <li target="rask-icon"><a href="javascript:;" (click)="scrollToView('raskicon')">icon</a></li>
        <li target="rask-info"><a href="javascript:;" (click)="scrollToView('raskinfo')">info</a></li>
        <li target="rask-helpicon"><a href="javascript:;" (click)="scrollToView('raskhelpicon')">help icon</a></li>

        <li target="rask-busy-spinner"><a href="javascript:;" (click)="scrollToView('raskbusyspinner')">busy spinner</a>
        </li>
        <li target="rask-pillbox"><a href="javascript:;" (click)="scrollToView('pillbox')">Pillbox</a></li>

        <li class="category">Info</li>
        <li target="rask-validation"><a href="javascript:;" (click)="scrollToView('rask-validation')">Validering</a>
        </li>
        <li target="rask-info"><a href="javascript:;" (click)="scrollToView('rask-info')">Information (todo)</a></li>

        <li class="category">Inputs</li>
        <li target="rask-input"><a href="javascript:;" (click)="scrollToView('raskinput')">input</a></li>
        <li target="rask-input-number"><a href="javascript:;" (click)="scrollToView('raskinputnumber')">input-number</a>
        </li>
        <li target="rask-textarea"><a href="javascript:;" (click)="scrollToView('rasktextarea')">textarea</a></li>
        <li target="rask-textmultiline"><a href="javascript:;"
                (click)="scrollToView('rasktextmultiline')">textmultiline</a></li>
        <li target="rask-radiobutton-group"><a href="javascript:;"
                (click)="scrollToView('raskradiobuttongroup')">radiobutton-group</a></li>
        <li target="rask-datepicker-block"><a href="javascript:;"
                (click)="scrollToView('raskdatepickerblock')">datepicker</a></li>
        <li target="rask-datepicker-interval-block"><a href="javascript:;"
                (click)="scrollToView('raskdatepickerintervalblock')">datepicker-interval</a></li>
        <li target="rask-selector"><a href="javascript:;" (click)="scrollToView('raskselector')">selector</a></li>
        <li target="rask-multi-selector"><a href="javascript:;"
                (click)="scrollToView('raskmultiselector')">multi-selector</a></li>
        <li target="rask-simple-selector"><a href="javascript:;"
                (click)="scrollToView('rasksimpleselector')">simple-selector</a></li>
        <li target="rask-tree-selector"><a href="javascript:;"
                (click)="scrollToView('rasktreeselector')">tree-selector</a></li>
        <li target="rask-multi-range-selector"><a href="javascript:;"
                (click)="scrollToView('raskmultirangeselector')">multi-range-selector</a></li>
        <li target="rask-tag"><a href="javascript:;" (click)="scrollToView('rasktag')">tag</a></li>
        <li target="rask-slider"><a href="javascript:;" (click)="scrollToView('raskslider')">slider</a></li>
        <li target="rask-span"><a href="javascript:;" (click)="scrollToView('raskspan')">span</a></li>
        <li target="rask-label"><a href="javascript:;" (click)="scrollToView('rasklabel')">label</a></li>
        <li target="rask-text-expander"><a href="javascript:;" (click)="scrollToView('rasktextexpander')">text
                expander</a></li>

        <li class="category">Knappar</li>
        <li target="rask-button"><a href="javascript:;" (click)="scrollToView('rask-button')">button</a></li>
        <li target="rask-submit-button"><a href="javascript:;"
                (click)="scrollToView('rasksubmitbutton')">submit-button</a></li>
        <li target="rask-save-button"><a href="javascript:;" (click)="scrollToView('rasksavebutton')">save-button</a>
        </li>
        <li target="rask-action-button"><a href="javascript:;"
                (click)="scrollToView('raskactionbutton')">action-button</a></li>
        <li target="rask-menu-button"><a href="javascript:;" (click)="scrollToView('raskmenubutton')">menu-button
                (template)</a></li>
        <li target="rask-button-select"><a href="javascript:;"
                (click)="scrollToView('raskmenubutton-options')">menu-button (options)</a></li>

        <li class="category">Tabeller</li>
        <li target="rask-table"><a href="javascript:;" (click)="scrollToView('rasktable')">table</a></li>

        <li class="category">Listor</li>
        <li target="rask-list"><a href="javascript:;" (click)="scrollToView('rasklist')">list</a></li>
        <li target="rask-div-list"><a href="javascript:;" (click)="scrollToView('raskdivlist')">div list</a></li>

        <li class="category">Pipes</li>
        <li target="rask-pipe-string-format"><a href="javascript:;"
                (click)="scrollToView('raskpipestringformat')">string-format</a></li>
        <li target="rask-pipe-linkify"><a href="javascript:;" (click)="scrollToView('raskpipelinkify')">linkify</a></li>
        <li target="rask-pipe-newlines"><a href="javascript:;" (click)="scrollToView('raskpipenewlines')">newlines</a>
        </li>
        <li target="rask-pipe-highlight"><a href="javascript:;"
                (click)="scrollToView('raskpipehighlight')">highlight</a></li>
        <li target="rask-pipe-filter"><a href="javascript:;" (click)="scrollToView('raskpipefilter')">filter</a></li>
    </ul>
</div>

<form [formGroup]="form">
    <div class="examples">

        <div class="example" id="rask-page">
            <rask-header size="4" noPadding>Exempelsida</rask-header>
            <div>
                <p>
                    Exempelsidan använder flertalet av dessa komponenter för att bygga upp ett hyfsat vanligt flöde av
                    komponenter
                </p>
                <a routerLink="/components/example">Komponenter i formulär</a>
            </div>
            <a id="raskpage"></a>
            <rask-header size="4" noPadding>Rask page</rask-header>
            <p>
                En page container tänkt att ligga i roten av en vy eller sida<br>
                Består av 2 sektioner där 1 hämtas ur element som attribut-taggas<br>
                <strong>pageTitle</strong> Titel<br>
                <strong>actionShow</strong> Om händelseknapp ska visas eller inte<br>
                <strong>actionTitle</strong> Titel på händelse<br>
                <strong>actionFn</strong> Metod att köra när någon trycker på händelseknappen<br>
                <strong>footerShow</strong> Ifall footer skall visas eller inte<br>
                <strong>contentShow</strong> Ifall content skall visas eller inte<br>
                <strong>noPadding</strong> Ifall sann visas ingen padding visas i bodyn för tex. sök sidor<br>
                <strong>headerContent</strong> Innehåll till header (valfritt)<br>
                <strong>footerContent</strong> Innehåll till footer (valfritt)<br>
                Allt annat hamnar i "bodyn" för containern
            </p>
            <code>
        &lt;rask-page pageTitle=&quot;Namn pa sidan&quot;&gt; [actionShow]=&quot;true&quot;&gt;
        [actionFn]=&quot;logPage&quot;&gt; actionTitle=&quot;Lägg till&quot;&gt; &gt;<br>
        &lt;ng-container headerContent&gt;
        &lt;rask-input label=&quot;Exempel input&quot;&gt; id=&quot;searchField&quot;&gt;&lt;/rask-input&gt;<br>
        &lt;rask-button color=&quot;secondary&quot;&gt;S&ouml;k&lt;/rask-button&gt;<br>
        &lt;/ng-container&gt;<br>
        &lt;rask-container-block&gt;<br>
        &lt;ng-container header&gt;Sektion1&lt;/ng-container&gt;<br>
        &lt;rask-input label=&quot;Exempel input&quot;&gt;&lt;/rask-input&gt;<br>
        &lt;/rask-container-block&gt;<br>
        &lt;rask-container-block&gt;<br>
        &lt;ng-container header&gt;Sektion2&lt;/ng-container&gt;<br>
        &lt;rask-input label=&quot;Exempel input&quot;&gt;&lt;/rask-input&gt;<br>
        &lt;/rask-container-block&gt;<br>
        &lt;ng-container footerContent&gt;
        &lt;rask-button color=&quot;primary&quot;&gt;S&ouml;k&lt;/rask-button&gt;<br>
        &lt;/ng-container&gt;<br>
        &lt;/rask-page&gt;
      </code>
            <rask-page pageTitle="Namn på sidan" [actionShow]="true" [actionFn]="logPage" actionTitle="Lägg till"
                [footerShow]="false">
                <ng-container headerContent>
                    <rask-input label="Exempel input" id="searchField"></rask-input>
                    <rask-button color="secondary">Sök</rask-button>
                </ng-container>
                <rask-container-block [noBorder]="true">
                    <ng-container header>Sektion1</ng-container>
                    <rask-input label="Exempel input"></rask-input>
                </rask-container-block>
                <rask-container-block [noBorder]="true">
                    <ng-container header>Sektion2</ng-container>
                    <rask-input label="Exempel input"></rask-input>
                </rask-container-block>
                <ng-container footerContent>
                    <rask-button color="primary">Spara</rask-button>
                </ng-container>
            </rask-page>
        </div>

        <div class="example" id="rask-container-block">
            <a id="raskcontainerblock"></a>
            <rask-header size="4" noPadding="true">Rask container block</rask-header>
            <p>
                En "master" container tänkt att ligga i roten av en vy eller komponent<br>
                Består av 3 sektioner där 2 hämtas ur element som attribut-taggas<br>
                <strong>header</strong> Innehåll till header (valfritt)<br>
                <strong>footer</strong> Innehåll till footer (valfritt)<br>
                Allt annat hamnar i "bodyn" för containern
            </p>
            <code>
        &lt;rask-container-block&gt;<br>
        &lt;ng-container header&gt;Header&lt;/ng-container&gt;<br>
        &lt;rask-input label=&quot;Exempel input&quot;&gt;&lt;/rask-input&gt;<br>
        &lt;ng-container footer&gt;<br>
        &lt;rask-button color=&quot;primary&quot;&gt;K&ouml;p&lt;/rask-button&gt;<br>
        &lt;rask-button color=&quot;secondary&quot;&gt;S&auml;lj&lt;/rask-button&gt;<br>
        &lt;/ng-container&gt;<br>
        &lt;/rask-container-block&gt;
      </code>
            <rask-container-block>
                <ng-container header>Header</ng-container>
                <rask-input label="Exempel input"></rask-input>
                <ng-container footer>
                    <rask-button color="primary">Köp</rask-button>
                    <rask-button color="secondary">Sälj</rask-button>
                </ng-container>
            </rask-container-block>
        </div>

        <div class="example" id="rask-toggle-panel">
            <a id="rasktogglepanel"></a>
            <rask-header size="4" noPadding>Rask toggle panel</rask-header>
            <p>
                En panel som kan fällas ut/in och innehålla dynamisk markup i både header och body<br>
                Består av 2 sektioner som attribut-taggas<br>
                <strong>header</strong> Innehåll till header (valfritt)<br>
                <strong>body</strong> Innehåll till body (valfritt)<br>
            </p>
            <code>
        &lt;rask-toggle-panel label="En Toggle Panel" defaultExpanded="false" icon="far fa-info" showLoader="true"&gt;<br>
        &nbsp;&lt;ng-container header&gt;<br>
        &nbsp;&nbsp;DYNAMISKT INNEHÅLL<br>
        &nbsp;&nbsp;&lt;rask-checkbox class="low"&gt;&lt;/rask-checkbox&gt;<br>
        &nbsp;&lt;/ng-container&gt;<br>
        &nbsp;&lt;ng-container&gt;<br>
        &nbsp;&nbsp;Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
        been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of
        type and scrambled it to make a type specimen book. It has survived not only five centuries, but also
        the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
        with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
        publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br>
        &nbsp;&lt;/ng-container&gt;<br>
        &lt;/rask-toggle-panel&gt;
      </code>
            <rask-toggle-panel label="En Toggle-panel" [defaultExpanded]="false" (onToggle)="log($event)">
                <ng-container header>
                    DYNAMISKT INNEHÅLL
                    <rask-checkbox class="low"></rask-checkbox>
                </ng-container>
                <ng-container>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                    leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                    publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </ng-container>
            </rask-toggle-panel>
            <rask-toggle-panel label="En Toggle-panel med Action options align left" [defaultExpanded]="false">
                <ng-container header>
                    <rask-action-button icon="fas fa-plus" alignment="left" [options]="buttonOptions"
                        (optionSelected)="buttonSelect($event)">ACTION</rask-action-button>
                </ng-container>
                <ng-container>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                    leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                    publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </ng-container>
            </rask-toggle-panel>
            <rask-toggle-panel label="En Toggle-panel med Action options align right" [defaultExpanded]="false">
                <ng-container header>
                    <rask-action-button icon="fas fa-plus" alignment="right" [options]="buttonOptions"
                        (optionSelected)="buttonSelect($event)">ACTION</rask-action-button>
                </ng-container>
                <ng-container>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                    leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                    publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </ng-container>
            </rask-toggle-panel>
            <rask-toggle-panel label="En Toggle-panel Med Ikon" [defaultExpanded]="false" icon="fa-info">
                <ng-container>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                    leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                    publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </ng-container>
            </rask-toggle-panel>

            <rask-toggle-panel label="En Toggle-panel Med Spinner" [defaultExpanded]="false"
                [showLoader]="togglespinner">
                <ng-container>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                    leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                    with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                    publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    <rask-button (click)="togglespinner = !togglespinner">Toggle Loader</rask-button>
                </ng-container>
            </rask-toggle-panel>
        </div>

        <div class="example" id="rask-collapsable">
            <a id="raskcollapsable"></a>
            <rask-header size="4" noPadding>Rask Collapsable panel</rask-header>
            <p>
                En panel som kan fällas ut/in och innehålla dynamisk markup i både header och body<br>
                Består av 2 sektioner som attribut-taggas<br>
                <strong>header</strong> Innehåll till header (valfritt)<br>
                <strong>body</strong> Innehåll till body (valfritt)<br>
            </p>
            <code>
        &lt;rask-collapsable headerText=&quot;Rubrik&quot;&gt;
        Lorem Ipsum is simply dummy text of the printing...
        &lt;/rask-collapsable&gt;
      </code>
            <rask-collapsable headerText="Rubrik">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book. It has survived not only five centuries, but also the
                leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s
                with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </rask-collapsable>
        </div>

        <div class="example" id="rask-message-panel">
            <a id="raskmessagepanel"></a>
            <rask-header size="4" noPadding>Rask Message panel</rask-header>
            <p>
                En panel som innehåller olika typer av meddelanden grupperade på "severity"<br>
                <strong>numberOfItemsToDisplay</strong> Hur många meddelanden som ska visas utan att expandera panelen
                (default 5)<br>
                <strong>maxNumOfRows</strong> Hur många rader som ska visas för ett meddelande innan texten trunkeras
                (default 2)<br>
                <strong>labels</strong> Rubriktexter för de olika meddelandetyperna (överrider standardvärden
                IMessageLabel[])<br>
                <strong>items</strong> Meddelanden som Observable array
                (Observable&lt;IMessageModel[]&gt;&lt;/IMessageModel&gt;)<br>
                <strong>anchorClicked</strong> Handler för event när ett ankare för ett meddelande har klickats på<br>
            </p>
            <code>
        //markup<br>
        &lt;rask-message-panel<br>
        &nbsp;[numberOfItemsToDisplay]=&quot;2&quot;<br>
        &nbsp;[maxNumOfRows]=&quot;2&quot;<br>
        &nbsp;[labels]=&quot;messageLabels&quot;<br>
        &nbsp;[items]=&quot;messageItems&quot;<br>
        &nbsp;(anchorClick)=quot;log($event)quot;<br>
        &gt;<br>
        &lt;/rask-message-panel&gt;<br>
        <br>
          //typescript <br>
          messageLabels =
          {{ messageLabelsClone | json}}
          <br>
            messageItems =
            {{ messageItemsClone | json}}
          </code>
            <rask-message-panel
                [numberOfItemsToDisplay]="2"
                [maxNumOfRows]="2"
                [labels]="messageLabels"
                [items]="messageItemsAsObservable"
                (anchorClick)="log($event)">
            </rask-message-panel>
        </div>

        <div class="example" id="vertical-collapsable">
            <a id="verticalcollapsable"></a>
            <rask-header size="4" noPadding>Vertical-collapsable</rask-header>
            <p>
                En vertikal expanderbar panel för att dela områden på mitten<br>
                Attributen "left" & "right" används som selectorer för att placera innehållet i expandern.<br>
                <strong>direction</strong> "left", "right" eller "both", vilken sida som ska kunna stängas (default
                "left") <br>
                <strong>leftClass</strong> CSS-Klasser som ska wrappa och bestämma bredd på stängbar sida ex grid
                "col-6"<br>
                <strong>showBar</strong> true/false, visa block på sidan vid stängd istället för flik (default "false")
                <br>
                <strong>flapPosTop</strong> Pixlar att förskjuta visa/döljknappen (default: "5px")<br>

                <strong>rightSideCloseText</strong> Text för att dölja höger flik (default "Dölj") <br>
                <strong>leftSideCloseText</strong> Text för att dölja vänster flik (default "Dölj") <br>
                <strong>rightSideOpenText</strong> Text för att visa höger flik (default "Visa") <br>
                <strong>leftSideOpenText</strong> Text för att visa vänster flik (default "Visa") <br>
            </p>
            <strong>Template</strong>
            <code ngNonBindable>
              &lt;rask-vertical-collapsable leftClass=&quot;col-4&quot;&gt;<br>
              &nbsp;&nbsp;&lt;div left&gt;<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&lt;div style=&quot;width: 100%; background-color:darkgrey; height:
              200px;&quot;&gt;&lt;/div&gt;<br>
              &nbsp;&nbsp;&lt;/div&gt;<br>
              &nbsp;&nbsp;&lt;div right&gt;<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&lt;div style=&quot;width: 100%; background-color:grey; height:
              200px;&quot;&gt;&lt;/div&gt;<br>
              &nbsp;&nbsp;&lt;/div&gt;<br>
              &lt;/rask-vertical-collapsable&gt;<br>
              <br>
                <br>
                  &lt;rask-vertical-collapsable leftClass=&quot;col-4&quot; direction=&quot;both&quot;
                  [showBar]=&quot;true&quot;&gt;<br>
                  &nbsp;&nbsp;&lt;div left&gt;<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&lt;div style=&quot;width: 100%; background-color:grey; height:
                  200px;&quot;&gt;&lt;/div&gt;<br>
                  &nbsp;&nbsp;&lt;/div&gt;<br>
                  &nbsp;&nbsp;&lt;div right&gt;<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&lt;div style=&quot;width: 100%; background-color:darkgrey; height:
                  200px;&quot;&gt;&lt;/div&gt;<br>
                  &nbsp;&nbsp;&lt;/div&gt;<br>
                  &lt;/rask-vertical-collapsable&gt;<br>
                </code>
            <strong>Resultat</strong>
            <rask-vertical-collapsable leftClass="col-4">
                <div left>
                    <div style="width: 100%; background-color:darkgrey; height: 200px;"></div>
                </div>
                <div right>
                    <div style="width: 100%; background-color:grey; height: 200px;"></div>
                </div>
            </rask-vertical-collapsable>

            <rask-vertical-collapsable leftClass="col-8" direction="both" [showBar]="true">
                <div left>
                    <div style="width: 100%; background-color:grey; height: 200px;"></div>
                </div>
                <div right>
                    <div style="width: 100%; background-color:darkgrey; height: 200px;"></div>
                </div>
            </rask-vertical-collapsable>
        </div>

        <div class="example" id="rask-card">
            <a id="raskcard"></a>
            <rask-header size="4" noPadding>Rask Card</rask-header>
            <p>
                Ett kort som kan innehålla dynamisk markup i både header och body<br>
                Består av 2 sektioner som attribut-taggas<br>
                <strong>label</strong> Rubrik<br>
                <strong>href</strong> Eventuell länk (valfritt)<br>
                <strong>size</strong> Storlek på rubrik (valfritt)<br>
                <strong>intent</strong> Styr vilken ikon som visas (valfritt, 'save', 'edit', 'delete')<br>
                <strong>iconClick</strong> Metod att binda mot vid klick på ikon (valfritt)<br>
                <strong>body</strong> Innehåll till body (valfritt)<br>
                <strong>headerIcon</strong> Ikon referens för att visa bild koplat till rubriken<br>
            </p>
            <code>
                  &lt;rask-cards&gt;<br>
                  &nbsp;&nbsp;&lt;rask-card label="Rubrik" href="http://www.sveaskog.se" [size]="4" intent="save" (iconClick)="log('pling')"&gt;<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&lt;ng-container&gt;<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lorem Ipsum is simply dummy text of the printing...<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&lt;/ng-container&gt;<br>
                  &nbsp;&nbsp;&lt;/rask-card&gt;<br>
                  &lt;/rask-cards&gt;<br>
                </code>
            <rask-cards>
                <rask-card label="Rubrik" href="http://www.sveaskog.se" [size]="4" intent="save"
                    headerIcon="far fa-exclamation-triangle"
                    (iconClick)="log('pling')">
                    <ng-container>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                        the
                        industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of
                        type
                        and scrambled it to make a type specimen book. It has survived not only five centuries, but also
                        the
                        leap into electronic typesetting, remaining essentially unchanged. It was popularised in the
                        1960s
                        with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with
                        desktop
                        publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </ng-container>
                </rask-card>
            </rask-cards>
        </div>

        <div class="example" id="rask-header">
            <a id="raskheader"></a>
            <rask-header size="4" noPadding>Rask header</rask-header>
            <p>
                <strong>size</strong> 2,3 & 4 beroende på placering<br>
                <strong>underline</strong> om en avskiljare under headern ska synas eller inte<br>
                <strong>noPadding</strong> om ingen padding ska användas<br>
            </p>
            <code>
                  &lt;rask-header size=&quot;2&quot; underline&gt;Titel&lt;/rask-header&gt;
                </code>
            <rask-header size="2" underline>Titel</rask-header>
        </div>

        <div class="example" id="rask-tabs">
            <a id="rasktabs"></a>
            <rask-header size="4" noPadding>Rask tabs</rask-header>
            <p>
                <strong>Rask-Tabs</strong><br>
                <strong>parameterName</strong> Namn på urlparameter som håller state<br>
                <strong>class</strong> "child": undertabbar, "parent": huvudtabbar<br>
                <strong>size</strong> storlek på tabbarna<br>
                <strong>wrap</strong> om tab-raden skall radbryta vid radslut<br>
                <br>
                <strong>Rask-Tab</strong><br>
                <strong>label</strong> Namn för tabben <br>
                <strong>routeId</strong> Id för urlparameter<br>
                <br>
                "Rask-tabs" ska innehålla ett antal "rask-tab" som wrappar innehållet.<br>
                "parameterName" och "routeId" används om man vill hålla tab-state i urlen. Då måste även routing sättas
                upp korrekt.<br>
                Om man vill använda sig av en undermeny bör man ge tabbarn klasserna "parent" samt "child"<br>

            </p>
            <code>
                      &lt;rask-tabs parameterName=&quot;section&quot; class=&quot;parent&quot; size=&quot;4&quot; [wrap]=&quot;true&quot;&gt;<br>
                      &nbsp;&nbsp; &lt;rask-tab label=&quot;Section 1&quot; routeId=&quot;section1&quot;&gt;<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&lt;rask-tabs parameterName=&quot;tab&quot; class=&quot;child&quot;&gt;<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;rask-tab label=&quot;Tab 1&quot;
                      routeId=&quot;tab1&quot;&gt;inneh&#229;ll 1&lt;/rask-tab&gt;<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;rask-tab label=&quot;Tab 2&quot;
                      routeId=&quot;tab2&quot;&gt;inneh&#229;ll 2&lt;/rask-tab&gt;<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;rask-tab label=&quot;Tab 3&quot;
                      routeId=&quot;tab3&quot;&gt;inneh&#229;ll 3&lt;/rask-tab&gt;<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&lt;/rask-tabs&gt;<br>
                      &nbsp;&nbsp;&lt;/rask-tab&gt;<br>
                      &nbsp;&nbsp;&lt;rask-tab label=&quot;Section 2&quot; routeId=&quot;section2&quot;&gt;inneh&#229;ll
                      2&lt;/rask-tab&gt;<br>
                      &nbsp;&nbsp;&lt;rask-tab label=&quot;Section 3&quot; routeId=&quot;section3&quot;&gt;inneh&#229;ll
                      3&lt;/rask-tab&gt;<br>
                      &lt;/rask-tabs&gt;<br>
                    </code>

            <code>
                      .state("showroom", {{'{'}}<br>
                      &nbsp;&nbsp;url: "/components/:section/:tab",<br>
                      &nbsp;&nbsp;component: ShowroomComponent,<br>
                      &nbsp;&nbsp;data: {{'{'}}<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;publicAccess: true<br>
                      &nbsp;&nbsp;{{'}'}},<br>
                      &nbsp;&nbsp;params: {{'{'}}<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;tab: {{'{'}} squash: true, value: null, dynamic: true {{'}'}},<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;section: {{'{'}} squash: true, value: null, dynamic: true {{'}'}}<br>
                      &nbsp;&nbsp;{{'}'}}<br>
                      {{'}'}})<br>
                    </code>
            <rask-tabs parameterName="section" layout="parent" aid="parent" [size]="4" [wrap]="true">
                <rask-tab label="Section 1" routeId="section1">
                    <rask-tabs parameterName="tab" layout="child" aid="child">
                        <rask-tab label="Tab 1" routeId="tab1">innehåll 1</rask-tab>
                        <rask-tab label="Tab 2" routeId="tab2">innehåll 2</rask-tab>
                        <rask-tab label="Tab 3" routeId="tab3">innehåll 3</rask-tab>
                        <rask-tab label="Tab 4" routeId="tab3">innehåll 4</rask-tab>
                        <rask-tab label="Tab 5" routeId="tab3">innehåll 5</rask-tab>
                        <rask-tab label="Tab 6" routeId="tab3">innehåll 6</rask-tab>
                        <rask-tab label="Tab 7" routeId="tab3">innehåll 7</rask-tab>
                        <rask-tab label="Tab 8" routeId="tab3">innehåll 8</rask-tab>
                    </rask-tabs>
                </rask-tab>
                <rask-tab label="Section 2" routeId="section2">innehåll 2</rask-tab>
                <rask-tab label="Section 3" routeId="section3">innehåll 3</rask-tab>
                <rask-tab label="Section 4" routeId="section3">innehåll 4</rask-tab>
                <rask-tab label="Section 5" routeId="section3">innehåll 5</rask-tab>
                <rask-tab label="Section 6" routeId="section3">innehåll 6</rask-tab>
                <rask-tab label="Section 7" routeId="section3">innehåll 7</rask-tab>
                <rask-tab label="Section 8" routeId="section3">innehåll 8</rask-tab>
                <rask-tab label="Section 9" routeId="section3">innehåll 9</rask-tab>
                <rask-tab label="Section 10" routeId="section3">innehåll 10</rask-tab>
                <rask-tab label="Section 11" routeId="section3">innehåll 11</rask-tab>
                <rask-tab label="Section 12" routeId="section3">innehåll 12</rask-tab>
            </rask-tabs>
        </div>

        <div class="example" id="rask-icon">
            <a id="raskicon"></a>
            <rask-header size="4" noPadding>Rask ikon</rask-header>
            <p>
                <strong>text</strong> Text till info<br>
                Innehållet i komponenten visas i popovern<br>
                text: texten som skall visas i popupen - om inte content i komponenten finns<br>
                icon: fa-icon som används<br>
                clickToOpen : när true, öppnas endast tooltip:et om man klickar på ikonen.<br>
            </p>
            <code>
                      &lt;rask-icon icon=&quot;fal fa-clock&quot;&gt;&lt;/rask-icon&gt;<br>
                      <br>
                        &lt;rask-icon icon=&quot;fal fa-wrench&quot; text=&quot;fix&quot;&gt;&lt;/rask-icon&gt;<br>
                        <br>
                          &lt;rask-icon icon=&quot;fal fa-code&quot;&gt;<br>
                          &nbsp;&nbsp;&lt;code&gt;code&lt;/code&gt;<br>
                          &nbsp;&nbsp;&lt;rask-button color=&quot;primary&quot;&gt;Accept&lt;/rask-button&gt;<br>
                          &lt;/rask-icon&gt;<br>
                          <br>
                            &lt;rask-icon icon=&quot;fal fa-mouse&quot; [clickToOpen]=&quot;true&quot;&gt;<br>
                            &nbsp;&nbsp;&lt;b&gt;Popup shows on click&lt;/b&gt;<br>
                            &lt;/rask-icon&gt;<br>
                            <br>
                              &lt;rask-icon icon=&quot;fal fa-hammer&quot; popoverTriggers=&quot;raskDefault&quot; [autoClose]=&quot;false&quot;&gt;
                              &lt;b&gt;Popup shows as normal&lt;/b&gt;
                              &lt;p&gt;If the user is quick enough to move mouse onto template, it will not close&lt;/p&gt;
                              &lt;p&gt;If the user is too slow the template will close&lt;/p&gt;
                              &lt;p&gt;The template will always close if the mouse leaves the template element&lt;/p&gt;
                              &lt;rask-button&gt;Click me&lt;/rask-button&gt;
                              &lt;/rask-icon&gt;
                              <br>
                                &lt;rask-icon-stacked icon=&quot;fal fa-pepper-hot&quot; icon2=&quot;fal fa-slash&quot;&gt;<br>
                                &nbsp;&nbsp;&lt;b&gt;Icon is stacked (pepper + slash)&lt;/b&gt;<br>
                                &lt;/rask-icon-stacked&gt;<br>
                              </code>
            <rask-icon icon="fal fa-clock"></rask-icon>
            <rask-icon icon="fal fa-wrench" text="fix"></rask-icon>
            <rask-icon icon="fal fa-code">
                <code>code</code>
                <rask-button color="primary">Accept</rask-button>
            </rask-icon>
            <rask-icon icon="fal fa-mouse" [clickToOpen]="true">
                <b>Popup shows on click</b>
            </rask-icon>
            <rask-icon icon="fal fa-hammer" popoverTriggers="raskDefault" [autoClose]="false">
                <b>Popup shows as normal</b>
                <p>If the user is quick enough to move mouse onto template, it will not close</p>
                <p>If the user is too slow the template will close</p>
                <p>The template will always close if the mouse leaves the template element</p>
                <rask-button>Click me (no close)</rask-button>
            </rask-icon>
            <rask-icon-stacked icon="fal fa-pepper-hot" icon2="fal fa-slash">
                <b>Icon is stacked (pepper + slash)</b>
            </rask-icon-stacked>

        </div>

        <div class="example" id="rask-info">
            <a id="raskinfo"></a>
            <rask-header size="4" noPadding>Rask info</rask-header>
            <p>
                <strong>text</strong> Text till info<br>
                Innehållet i komponenten visas i popovern
            </p>
            <code>
                                &lt;label&gt;
                                Kryptisk label
                                &lt;rask-info&gt;F&ouml;rklarande text&lt;/rask-info&gt;
                                &lt;/label&gt;
                              </code>
            <label>
                Kryptisk label
                <rask-info>Förklarande text</rask-info>
            </label>
        </div>

        <div class="example" id="rask-helpicon">
            <a id="raskhelpicon"></a>
            <rask-header size="4" noPadding>Rask helpicon</rask-header>
            <p>
                <strong>helpUrl</strong> Url till sida för användarhandledning<br>
                Komponenten ärver rask-icon om help url används kommer muspekare ändras till help samt att ikonen blir
                klickbar och öppnar url i ny tab.
            </p>
            <code>
                                &lt;rask-helpicon helpUrl="https://sveaskog.sharepoint.com/sites/glantan/Sidor/Start.aspx" &gt;&lt;/rask-helpicon&gt;
                              </code>
            <label>
                <rask-helpicon helpUrl="https://sveaskog.sharepoint.com/sites/glantan/Sidor/Start.aspx"></rask-helpicon>
            </label>
        </div>

        <div class="example" id="rask-busy-spinner">
            <a id="raskbusyspinner"></a>
            <rask-header size="4" noPadding>Rask busy spinner</rask-header>
            <p>
                <strong>size</strong> 1,2,3,4 och 5<br>
            </p>
            <code>
                                &lt;rask-busy-spinner size=&quot;2&quot; &gt;/rask-busy-spinner&gt;
                              </code>
            <rask-busy-spinner size="1"></rask-busy-spinner>
            <rask-busy-spinner size="2"></rask-busy-spinner>
            <rask-busy-spinner size="3"></rask-busy-spinner>
            <rask-busy-spinner size="4"></rask-busy-spinner>
            <rask-busy-spinner size="5"></rask-busy-spinner>
        </div>


        <div class="example" id="rask-busy-tree">
            <a id="raskbusytree"></a>
            <rask-header size="4" noPadding>Rask busy tree</rask-header>
            <p>
                <strong>size</strong> 1,2,3,4 och 5<br>
                <strong>type</strong> normal, julgran, auto<br>
            </p>
            <code>
                                &lt;rask-busy-tree type=&quot;auto&quot; size=&quot;2&quot; &gt;/rask-busy-tree&gt;
                              </code>
            <rask-busy-tree size="1" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="2" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="3" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="4" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="5" class="m-1"></rask-busy-tree>

            <code>
                                &lt;rask-busy-tree type=&quot;normal&quot; size=&quot;2&quot; &gt;/rask-busy-tree&gt;
                              </code>
            <rask-busy-tree size="1" type="normal" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="2" type="normal" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="3" type="normal" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="4" type="normal" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="5" type="normal" class="m-1"></rask-busy-tree>

            <code>
                                &lt;rask-busy-tree type=&quot;julgran&quot; size=&quot;2&quot; &gt;/rask-busy-tree&gt;
                              </code>
            <rask-busy-tree size="1" type="julgran" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="2" type="julgran" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="3" type="julgran" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="4" type="julgran" class="m-1"></rask-busy-tree>
            <rask-busy-tree size="5" type="julgran" class="m-1"></rask-busy-tree>
        </div>


        <div class="example" id="rask-pillbox">
            <a id="pillbox"></a>
            <rask-header size="4" noPadding>Rask pillbox</rask-header>
            <p>
                <strong>Text</strong> Text till komponenten<br>
                Innehållet i komponenten visas i komponenten kan tex vara en rask-icon med popover<br>
            </p>
            <code>
                                &lt;rask-pillbox text=&quot;Demo&quot;&gt;<br>
                                &nbsp;&nbsp;&lt;rask-icon icon="far fa-edit" [clickToOpen]="true"&gt;<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&lt;b&gt;Poppover med eventuell redigering&lt;/b&gt;<br>
                                &nbsp;&nbsp;&lt;/rask-icon&gt;<br>
                                &lt;/rask-pillbox&gt;
                              </code>
            <div style="width: 110px;">
                <rask-pillbox text="Demo">
                    <rask-icon icon="far fa-edit" [clickToOpen]="true">
                        <b>Poppover med eventuell redigering</b>
                    </rask-icon>
                </rask-pillbox>
            </div>
        </div>



        <div class="example" id="rask-inline-toast">
            <a id="raskinlinetoast"></a>
            <rask-header size="4" noPadding>Rask inline toast</rask-header>

            <code>
                                &#x3C;rask-inline-toast
                                [showToast]=&#x22;trigger$&#x22;
                                [viewInMillisseconds]=&#x22;1000&#x22;&#x3E;
                                H&#xE4;r &#xE4;r en toast!
                                &#x3C;/rask-inline-toast&#x3E;
                              </code>

            <rask-container-block>
                <ng-container header>Visa toast 1 sek</ng-container>

                <rask-button (click)="inlineToast1$.next()">1 sek</rask-button>
                <br>
                <br>
                <rask-inline-toast
                    [showToast]="inlineToast1$"
                    [viewInMillisseconds]="1000">
                    Här är en toast!
                </rask-inline-toast>
            </rask-container-block>

            <rask-container-block>
                <ng-container header>Visa toast 10 sek</ng-container>

                <rask-button (click)="inlineToast10$.next()">10 sek</rask-button>
                <br>
                <br>
                <rask-inline-toast
                    [showToast]="inlineToast10$"
                    [viewInMillisseconds]="10000">
                    Här är en till Toast!
                </rask-inline-toast>
            </rask-container-block>
        </div>

        <div class="example" id="rask-input">
            <a id="raskinput"></a>
            <rask-header size="4" noPadding>Inputfält för textdata</rask-header>
            <p>
                <strong>label</strong> är titeln över inputfältet. <br>
                <strong>formControlName</strong> styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>[rule]</strong> Valideringsregel att binda fältet mot.<br>
                <strong>infoText</strong> Text till valbar info-ikon.<br>
                <strong>[maxlength]</strong> VaMaximalt antal tecken som får matas in. Allt under 1 tillåter oändligt.
            </p>
            <code>
                                        &lt;rask-input label=&quot;Exempel&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input&gt;<br>
                                        &lt;rask-input label=&quot;Exempel - disabled&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot; [disabled]=&quot;true&quot;&gt;&lt;/rask-input&gt;<br>
                                        &lt;rask-input label=&quot;Exempel - infotext&quot;
                                        infoText=&quot;Förklarande text&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input&gt;<br>
                                        &lt;rask-input label=&quot;Exempel&quot; [maxlength]=&quot;20&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input&gt;
                                      </code>
            <rask-input label="Exempel" value="Lorem Ipsum"></rask-input>
            <rask-input label="Exempel - disabled" [disabled]="true" value="Lorem Ipsum"></rask-input>
            <rask-input label="Exempel - infotext" infoText="Förklarande text" value="Lorem Ipsum"></rask-input>
            <rask-input label="Exempel" [maxlength]="20" value="Lorem Ipsum"></rask-input>
        </div>

        <div class="example" id="rask-input-number">
            <a id="raskinputnumber"></a>
            <rask-header size="4" noPadding>Inputfält för nummerfält</rask-header>
            <p>
                <strong>label</strong> Titeln över inputfältet. <br>
                <strong>formControlName</strong> Styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>[rule]</strong> Valideringsregel att binda fältet mot.<br>
                <strong>infoText</strong> Text till valbar info-ikon.<br>
                <strong>inputGroup</strong> Text till input group.
            </p>
            <code>
                                        &lt;rask-input-number label=&quot;Exempel&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input-number&gt;<br>
                                        &lt;rask-input-number label=&quot;Exempel&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot; [disabled]=&quot;true&quot;&gt;&lt;/rask-input-number&gt;<br>
                                        &lt;rask-input-number label=&quot;Exempel&quot;
                                        infoText=&quot;Förklarande text&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input-number&gt;<br>
                                        &lt;rask-input-number label=&quot;Kordinat&quot;
                                        inputGroup=&quot;N&quot;
                                        formControlName=&quot;fromgroupPropertyName&quot;&gt;&lt;/rask-input-number&gt;
                                      </code>
            <rask-input-number label="Exempel för nummer" value="123"></rask-input-number>
            <rask-input-number label="Exempel för nummer" value="123" [disabled]="true"></rask-input-number>
            <rask-input-number label="Exempel för nummer" infoText="Förklarande text"></rask-input-number>
            <rask-input-number label="Kordinat" inputGroup="N"></rask-input-number>
        </div>

        <div class="example" id="rask-textarea">
            <a id="rasktextarea"></a>
            <rask-header size="4" noPadding>Inputfält för multiline</rask-header>
            <p>
                <strong>label</strong> är titeln över inputfältet. <br>
                <strong>formControlName</strong> styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>[rule]</strong> Valideringsregel att binda fältet mot.<br>
                <strong>infoText</strong> Text till valbar info-ikon.<br>
                <strong>maxlength</strong> Maximalt antal tecken som får matas in. Allt under 1 tillåter oändligt
                antal.<br>
                <strong>rows</strong> Styr hur högt fältet är i antal rader.<br>
            </p>
            <code>
                                        &lt;rask-textarea label=&quot;Exempel 1&quot; [rows]=&quot;3&quot; infoText=&quot;Beskrivning f&ouml;r
                                        Exempel 1&quot;&gt;&lt;/rask-textarea&gt;
                                        &lt;rask-textarea label=&quot;Exempel 2&quot; [rows]=&quot;3&quot; [maxlength]=&quot;20&quot;
                                        infoText=&quot;Beskrivning f&ouml;r Exempel 2&quot;&gt;&lt;/rask-textarea&gt;
                                      </code>
            <rask-textarea label="Exempel 1" [rows]="3" infoText="Beskrivning 1"></rask-textarea>
            <rask-textarea label="Exempel 2" [rows]="3" [maxlength]="20" infoText="Beskrivning 2"></rask-textarea>
        </div>

        <div class="example" id="rask-textmultiline">
            <a id="rasktextmultiline"></a>
            <rask-header size="4" noPadding>Readonlyfält för multiline</rask-header>
            <p>
                <strong>label</strong> är titeln över readonlyfältet. <br>
                <strong>value</strong> är en textrad som skall presenteras<br>
                <strong>values</strong> är flera textrader som skall presenteras, tar en strängarray<br>
            </p>
            <code>
                                        &lt;rask-textmultiline label=&quot;Exempel 1&quot; [value]=&quot;En rad&quot; f&ouml;r
                                        Exempel 1&quot;&gt;&lt;/rask-textmultiline&gt;<br>

                                        &lt;rask-textmultiline label=&quot;Exempel 2&quot; [values]=&quot;3&quot;
                                        f&ouml;r Exempel 2&quot;&gt;&lt;/rask-tetmultiline&gt;
                                      </code>
            <rask-textmultiline label="Exempel 1" value="En text"></rask-textmultiline>
            <rask-textmultiline label="Exempel 2" [values]="stringArray"></rask-textmultiline>
        </div>

        <div class="example" id="rask-checkbox">
            <a id="raskcheckbox"></a>
            <rask-header size="4" noPadding>Rask checkbox</rask-header>
            <p>
                <strong>text</strong> Text till checkbox<br>
                <strong>negative</strong> Flagga för att ge checkboxen ett negativt utseende<br>
                <strong>formControlName</strong> Styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>checked</strong> Alternativ binding, bra om man tex inte använder en formgroup<br>
            </p>
            <code>
                                        &lt;rask-checkbox text=&quot;Alternativ a&quot;&gt;&lt;/rask-checkbox&gt;<br>
                                        &lt;rask-checkbox text=&quot;Alternativ b&quot; disabled&gt;&lt;/rask-checkbox&gt;<br>
                                        &lt;rask-checkbox text=&quot;Alternativ c&quot; negative&gt;&lt;/rask-checkbox&gt;<br>
                                        &lt;rask-checkbox text=&quot;Alternativ a checked&quot;
                                        [(checked)]=&quot;checked&quot;&gt;&lt;/rask-checkbox&gt;
                                      </code>
            <rask-checkbox text="Alternativ a"></rask-checkbox>
            <rask-checkbox text="Alternativ b" [disabled]="true"></rask-checkbox>
            <rask-checkbox text="Alternativ c" negative></rask-checkbox>
            <rask-checkbox text="Alternativ a checked" [(checked)]="checked"></rask-checkbox>
        </div>

        <div class="example" id="rask-radiobutton-group">
            <a id="raskradiobuttongroup"></a>
            <rask-header size="4" noPadding>Rask radiobutton (group)</rask-header>
            <p>
                <strong>label</strong> är titeln över radiobuttongruppen. <br>
                <strong>negative</strong> Flagga för att ge radiobuttongruppen ett negativt utseende<br>
                <strong>formControlName</strong> Styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>helpUrl</strong> Url för att visa rask helpicon kopplat till rubriken<br>
                <strong>[buttons]</strong> En lista av key/value-objekt som populerar radiobuttongruppen med
                radiobuttons<br>
            </p>
            <code>
                                        &lt;rask-radiobutton-group label=&quot;Exempel 1&quot;
                                        [buttons]=&quot;radioButtonExamples.example1&quot;
                                        helpUrl=&quot;https://sveaskog.sharepoint.com/sites/glantan/Sidor/Start.aspx&quot;&gt;&lt;/rask-radiobutton-group&gt;<br />
                                        &lt;rask-radiobutton-group label=&quot;Exempel 2&quot;
                                        [buttons]=&quot;radioButtonExamples.example2&quot; [disabled]=&quot;true&quot;&gt;&lt;/rask-radiobutton-group&gt;<br />
                                        &lt;rask-radiobutton-group label=&quot;Exempel 3&quot;
                                        [buttons]=&quot;radioButtonExamples.example3&quot; negative&gt;&lt;/rask-radiobutton-group&gt;<br />
                                      </code>
            <rask-radiobutton-group label="Exempel 1" [buttons]="radioButtonExamples.example1"
                helpUrl="https://sveaskog.sharepoint.com/sites/glantan/Sidor/Start.aspx"></rask-radiobutton-group>
            <br />
            <rask-radiobutton-group label="Exempel 2" [buttons]="radioButtonExamples.example2" disabled>
            </rask-radiobutton-group><br />
            <rask-radiobutton-group label="Exempel 3" [buttons]="radioButtonExamples.example3" [negative]="true">
            </rask-radiobutton-group><br />
        </div>

        <div class="example" id="rask-datepicker-block">
            <a id="raskdatepickerblock"></a>
            <rask-header size="4" noPadding>Rask datepicker</rask-header>
            <p>
                <strong>label</strong> Titeln över datepickern. <br>
                <strong>formControlName</strong> Styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>minDate</strong> Minimum datum<br>
                <strong>onlyMonths</strong> Vid true sätts läge till att enbart välja månader<br>
            </p>
            <code>
                                        &lt;rask-datepicker label=&quot;Datum selector&quot;&gt;&lt;/rask-datepicker&gt;
                                      </code>
            <rask-datepicker label="Datum selector"></rask-datepicker>
            <rask-datepicker label="Datum selector disabled" [disabled]="true"></rask-datepicker>
            <code>
                                        &lt;rask-datepicker label=&quot;M&aring;nads selector&quot; minDate=&quot;2019-08-01&quot;
                                        [onlyMonths]=&quot;true&quot;&gt;&lt;/rask-datepicker&gt;
                                      </code>
            <rask-datepicker label="Månads selector" minDate="2019-08-01" [onlyMonths]="true"></rask-datepicker>
        </div>

        <div class="example" id="rask-datepicker-interval-block">
            <a id="raskdatepickerintervalblock"></a>
            <h4>Rask datepicker interval</h4>
            <p>
                Används vid val av datuminterval.<br>
                Vid val av startdatum begränsas minimumdatum för slutdatum till startdatumet.<br>
                Vid val av slutdatum begränsas maximumdatum för startdatum till slutdatumet.<br>
            </p>
            <p>
                <strong>labelStartDate</strong> Titeln över startdatum. <br>
                <strong>labelEndDate</strong> Titeln över slutdatum. <br>
                <strong>startDate</strong> Sätta startdatum<br>
                <strong>endDate</strong> Sätt slutdatum<br>
                <strong>(startDate)</strong> Valt startdatum<br>
                <strong>(endDate)</strong> Valt slutdatum<br>
                <strong>onlyMonths</strong> Vid true sätts läge till att enbart välja månader<br>
            </p>
            <code>
                                        &lt;rask-datepicker-interval
                                        labelStartDate=&quot;V&auml;lj period&quot;
                                        (startDate)=&quot;log($event)&quot;
                                        (endDate)=&quot;log($event)&quot;&gt;&lt;/rask-datepicker-interval&gt;
                                      </code>
            <rask-datepicker-interval labelStartDate="Välj period" (startDate)="log($event)" (endDate)="log($event)">
            </rask-datepicker-interval>
            <code>
                                        &lt;rask-datepicker-interval
                                        labelStartDate=&quot;fr.o.m&quot;
                                        labelEndDate=&quot;t.o.m&quot;
                                        startDate=&quot;2020-12-02&quot;
                                        endDate=&quot;2020-12-30&quot;
                                        (startDate)=&quot;log($event)&quot;
                                        (endDate)=&quot;log($event)&quot;
                                        [onlyMonths]=&quot;false&quot;&gt;&lt;/rask-datepicker-interval&gt;
                                      </code>
            <rask-datepicker-interval
                labelStartDate="fr.o.m"
                labelEndDate="t.o.m"
                startDate="2020-12-02"
                endDate="2020-12-30"
                (startDate)="log($event)"
                (endDate)="log($event)"
                [onlyMonths]="false">
            </rask-datepicker-interval>
        </div>

        <div class="example" id="rask-selector">
            <a id="raskselector"></a>
            <rask-header size="4" noPadding>Rask selector</rask-header>
            <p>
                <strong>Label</strong> Titel över selectorn <br>
                <strong>Values</strong> En array eller en Observable med värden som ska visas i selectorn<br>
                <strong>placeholder</strong> Text som ska visas innan något är valt<br>
                <strong>canDelete</strong> boolean, om det ska va möjligt att avvälja<br>
                <strong>rule</strong> Valideringsregler<br>
                <strong>exclude</strong> Värden som ska excluderas från dropdown-lista<br>
                <strong>groupBy</strong> Funktion för att plocka fram grupperingsvärde<br>
                <strong>search</strong> Funktion för att göra en async sökning med inmatade tecken<br>
                <strong>minCharacters</strong> Mininum med tecken för att göra en sökning<br>
                <strong>viewformatter</strong> Funktion för att formatera värde för visning<br>
                <strong>viewSelectedFormatter</strong> Funktion för att formatera valt värde för visning, om den inte är
                satt används viewFormatter<br>
                <strong>formatter</strong> Funktion som formaterar värdet som är valt<br>
                <strong>itemDisabled</strong> Funktion för att avgöra om värdet är valbart<br>
                <strong>showHeader</strong> Boolean, ifall en rubrik skall visas eller inte. Ifall sant så måste en
                &lt;ng-container header&gt;
                finnas i markup se exempel nedan<br>
                <strong>raskWebinstallning</strong> String, nyckel till webinställning som populerar dropdown.<br>
                <strong>addSearchTermToList</strong> Boolean, om det som skrivs in adderas sök-termen till listan.<br>
                <strong>allowAnyValue</strong> Boolean, gör det möjligt att skriva värden som inte ger någon träff.<br>
                <strong>addModelValueWhenMissing</strong> Funktion för att lägga till modellens värde om det saknas i
                listan med värden.<br>
                <strong>useItemIcons</strong> Boolean, gör det möjligt att använda bilder före text för de olika valen.
                används ihop med parametern imgFormatter<br>
                <strong>imgFormatter</strong> Funtion, för att hämta bild att visa före valet<br>
                Selectorn har en hel del parametrar, en grundregel är att om listan som kommer in antingen via values
                eller search är objekt krävs formaterare.
            </p>
            <code>
                                        &lt;rask-selector label=&quot;Vanlig selector&quot; [values]=&quot;['V&auml;rde 1', 'V&auml;rde 2',
                                        'V&auml;rde 3']&quot; [disabled]=&quot;false&quot;&gt;
                                      </code>
            <rask-selector class="col-3" label="Vanlig selector" [values]="stringArray" [useItemIcons]="true"
                [imgFormatter]="imgFormatter">
            </rask-selector>
            <rask-selector class="col-3" label="Vanlig selector disabled" [values]="stringArray"
                [disabled]="true">
            </rask-selector>
            <rask-selector class="col-3" label="Vanlig selector med allowAnyValue" [values]="stringArray"
                [allowAnyValue]="true">
            </rask-selector>
            <code>
                                        &lt;rask-selector label=&quot;Selector med grupper&quot; [values]=&quot;groupValues&quot;
                                        [groupBy]=&quot;groupBy&quot; [viewFormatter]=&quot;groupFormatter&quot;
                                        [formatter]=&quot;outputFormatter&quot;&gt;&lt;/rask-selector&gt;<br>
                                        <br>
                                          groupFormatter = (item) =&gt; item.v;<br>
                                          groupBy = (item) =&gt; item.g;<br>
                                          outputFormatter = (item) =&gt; !!item ? item.v : null;<br>
                                        </code>
            <rask-selector class="col-3" label="Selector med grupper" [values]="groupValues" [groupBy]="groupBy"
                [viewFormatter]="groupFormatter" [formatter]="outputFormatter"></rask-selector>
            <code>
                                          &lt;rask-selector label=&quot;Selector med rubrik&quot; [showHeader]=&quot;true&quot;
                                          [values]=&quot;['V&auml;rde 1', 'V&auml;rde 2',
                                          'V&auml;rde 3']&quot;&gt;
                                        </code>
            <rask-selector class="col-3" label="Selector med rubrik" [showHeader]="true"
                [values]="['Värde 1', 'Värde 2', 'Värde 3']">
                <ng-container header><span>Sveaskog AB&nbsp;<a href="http://www.sveaskog.se" target="_blank"><i
                                class="far fa-external-link" aria-hidden="true"></i></a></span></ng-container>
            </rask-selector>
        </div>

        <div class="example" id="rask-multi-selector">
            <a id="raskmultiselector"></a>
            <rask-header size="4" noPadding>Rask multi selector</rask-header>
            <p>
                <strong>label</strong> Titel över selectorn <br>
                <strong>bindLabel</strong> Egenskap i objekt att visa i urval och val<br>
                <strong>bindValue</strong> Egenskap i objekt att retunera som värde<br>
                <strong>groupBy</strong> Egenskap i objekt att gruppera efter<br>
                <strong>hideSelected</strong> Om sant de valda värdena visas inte i listan<br>
                <strong>items</strong> En Observable array av värden som ska visas<br>
                <strong>selected</strong> En array av valda värden<br>
                <strong>clearAllTooltipText</strong> Tooltip text som visas när man hovrar över x<br>
                <strong>searchFn</strong> Funktion att använda om man tex vi att list sökningen ska göras på två
                egenskaper i ett objekt<br>
                <strong>rule</strong> Valideringsregler<br>
                <strong>minTermLength</strong> Minst antal tecken vid sök gäller searchFn och typeaheadFn<br>
                <strong>loading</strong> Ifall laddningsindikatorn ska visas eller inte<br>
                <strong>loadingText</strong> Text som visas i dropdown när laddning sker<br>
                <strong>notFoundText</strong> Text som visas i dropdown när resultat saknas<br>
                <strong>typeToSearchText</strong> Text som visas i dropdown när typeahead sökning är aktiv<br>
                <strong>typeaheadFn</strong> Funktion att använda vid typeahead utsökningar<br>
                <br>
            </p>
            <code>
                                            &lt;rask-multi-selector label=&quot;Multi selector med databinding&quot;
                                            [items]=&quot;multiSelectData&quot; bindLabel=&quot;namn&quot; bindValue=&quot;value&quot;
                                            (change)=&quot;log($event)&quot; [selected]=&quot;model.multiSelect&quot;&gt;
                                          </code>
            <rask-multi-selector class="col-3" label="Multi selector med databinding" [items]="multiSelectData"
                bindLabel="namn" bindValue="value" (change)="log($event)" [selected]="model.multiSelect">
            </rask-multi-selector>
            <rask-multi-selector class="col-3" label="Disabled Multi selector med databinding" [items]="multiSelectData"
                bindLabel="namn" bindValue="value" (change)="log($event)" [selected]="model.multiSelect"
                [disabled]="true">
            </rask-multi-selector>
            <code>
                                            &lt;rask-multi-selector label=&quot;Multi selector med databinding&quot;
                                            [items]=&quot;multiSelectData&quot; bindLabel=&quot;namn&quot; bindValue=&quot;value&quot;
                                            groupBy=&quot;groupName&quot; (change)=&quot;log($event)&quot;
                                            [selected]=&quot;model.multiSelect&quot;&gt;
                                          </code>
            <rask-multi-selector class="col-3" label="Multi selector med grupper" [items]="multiSelectData"
                bindLabel="namn" bindValue="value" groupBy="groupName" (change)="log($event)"
                [selected]="model.multiSelect">
            </rask-multi-selector>
            <code>
                                            &lt;rask-multi-selector label=&quot;Multi selector med typeahead&quot; bindLabel=&quot;namn&quot;
                                            typeToSearchText=&quot;Ange minst två tecken!&quot; loadingText=&quot;Laddar...&quot;
                                            notFoundText=&quot;Ingen träff&quot; [minTermLength]=&quot;2&quot; [typeaheadFn]=&quot;getPeople&quot;
                                            (change)=&quot;log($event)&quot; &gt;
                                          </code>
            <rask-multi-selector class="col-3" label="Multi selector med typeahead" bindLabel="name"
                typeToSearchText="Ange minst två tecken!" loadingText="Laddar..." notFoundText="Ingen träff"
                [minTermLength]="2" [typeaheadFn]="getPeople" (change)="log($event)">
            </rask-multi-selector>
        </div>

        <div class="example" id="rask-simple-selector">
            <a id="rasksimpleselector"></a>
            <rask-header size="4" noPadding>Rask simple selector</rask-header>
            <p>
                <strong>label</strong> Titel över selectorn <br>
                <strong>bindLabel</strong> Egenskap i objekt att visa i urval och val<br>
                <strong>bindValue</strong> Egenskap i objekt att retunera som värde<br>
                <strong>values</strong> En Observable array av värden som ska visas<br>
                <strong>portalToBody</strong> Om dropdown ska bindas mot body eller ej<br>
                <strong>clearable</strong> Om det ska gå att avvälja ur listan<br>
                <strong>onBeforeChange</strong> Utvärderingsfunktion för att värde ska sättas om<br>
                <br>
            </p>
            <code>
                                              &lt;rask-simple-selector label=&quot;Simple selector med databinding&quot;
                                              [values]=&quot;multiSelectData&quot; bindLabel=&quot;namn&quot; bindValue=&quot;value&quot;
                                              (change)=&quot;log($event)&quot;
                                            </code>
            <rask-simple-selector class="col-3" label="Simple selector med databinding"
                [values]="multiSelectData"
                bindLabel="namn"
                bindValue="value"
                (change)="log($event)" [value]="model.select">
            </rask-simple-selector>
        </div>

        <div class="example" id="rask-tree-selector">
            <a id="rasktreeselector"></a>
            <rask-header size="4" noPadding>Rask tree/multi selector</rask-header>
            <p>
                <strong>label</strong> Titel över selectorn <br>
                <strong>items</strong> En array eller en Observable-lista med "SelectionItems" som ska visas<br>
                <strong>placeholder</strong> Text som ska visas innan något är valt<br>
                <strong>rule</strong> Valideringsregler<br>
                <strong>comparePredicate</strong> Jämförelsepredikat för att jämföra två värden och se om dessa är
                samma, krävs om värdena i listan är objekt.<br>
                <strong>displayValueFormatter</strong> Funktion för att formatera valda värdet som textboxen.<br>
                <strong>autoSort</strong> Funktion för att alltid sortera enligt sortExpression vid uppdatering av
                värden.<br>
                <strong>sortExpression</strong> Funktion för beskriva hur du vill att den skall sortera default sorterar
                den på namn.<br>
                <strong>selectionStrategyType</strong> Funktion för att välja hur automatisk selection av noder i trädet
                skall ske.<br>
                <strong>valueStrategyType</strong> Funktion för att välja hur valda objekt i listan presenteras.<br>
                <strong>showHeader</strong> Boolean, ifall en rubrik skall visas eller inte. Ifall sant så måste en
                &lt;ng-container header&gt;
                finnas i markup se exempel nedan<br>
                <br>
                Items som listas ska va av typen "SelectionItem", där "value" i detta objekt är det som kommer ut från
                komponenten.<br>
                Om "value" är ett objekt måste comparePredicate sättas för att komponenteten.<br>
                <br>
                Om inga children finns på "items" kommer komponenten bete sig som en multi-selector
            </p>
            <code>
                                                  &lt;rask-tree-selector label=&quot;Tr&auml;dselector med rubrik&quot;
                                                  [autoSort]=&quot;false&quot; [items]=&quot;treeSelectorValues&quot;&gt;&lt;/rask-tree-selector&gt;<br>
                                                  <br>
                                                    treeSelectorValues =
                                                    {{ treeClone | json}}
                                                  </code>
            <rask-tree-selector label="Trädselector" [autoSort]="false" [items]="treeSelectorValues">
            </rask-tree-selector>
            <rask-tree-selector label="Trädselector - disabled" [autoSort]="false" [items]="treeSelectorValues"
                [disabled]="true">
            </rask-tree-selector>
            <code>
                                                    //TS fil, sortera på namn fallande<br>
                                                    treeSelectorSortExpression = (a,b) => (a.text > b.text ? -1 : 1);<br>
                                                    //markup
                                                    &lt;rask-tree-selector label=&quot;Tr&auml;dselector med rubrik&quot;
                                                    [autoSort]=&quot;true&quot; [sortExpression]=&quot;treeSelectorSortExpression&quot;
                                                    [items]=&quot;treeSelectorValues&quot;&gt;&lt;/rask-tree-selector&gt;<br>
                                                    <br>
                                                      treeSelectorValues =
                                                      {{ treeClone | json}}
                                                    </code>
            <rask-tree-selector label="Trädselector" [autoSort]="true" [sortExpression]="treeSelectorSortExpression"
                [items]="treeSelectorValuesWithSorting"></rask-tree-selector>
            <code>
                                                      &lt;rask-tree-selector label=&quot;Tr&auml;dselector med rubrik&quot; [showHeader]=&quot;true&quot;
                                                      [items]=&quot;treeSelectorWithHeaderValues&quot;&gt;&lt;/rask-tree-selector&gt;<br>
                                                      <br>
                                                        treeSelectorValues =
                                                        {{ treeClone | json}}
                                                      </code>
            <rask-tree-selector label="Trädselector med rubrik" [showHeader]="true"
                [items]="treeSelectorWithHeaderValues">
                <ng-container header><span>Sveaskog AB&nbsp;<a href="http://www.sveaskog.se" target="_blank"><i
                                class="far fa-external-link" aria-hidden="true"></i></a></span></ng-container>
            </rask-tree-selector>
        </div>

        <div class="example" id="rask-multi-range-selector">
            <a id="raskmultirangeselector"></a>
            <rask-header size="4" noPadding>Rask multi-range selector</rask-header>
            <p>
                <strong>itemsTitle</strong> Titel över hela listan<br>
                <strong>items</strong> En array med alla värden som ska visas<br>
                <strong>valueTitle</strong> Titel över valda värden<br>
                <strong>value</strong> Valda värden<br>
                <strong>orderItemsBy</strong> Sorteringsfunktion för att sortera på ett särskilt värde i objektet för
                värdena till vänster (alla)<br>
                <strong>orderValueBy</strong> Sorteringsfunktion för att sortera på ett särskilt värde i objektet för
                värdena till höger (valda)<br>
                <strong>viewFormatter</strong> Funktion för att visa upp värdet i listan<br>
                <strong>allowValueSort</strong> Avgör om man ska manuellt få sortera värde-listan (valda) <br>
                <strong>size</strong> Höjden på listorna. Default: 20<br>
            </p>
            <code>
                                                        &lt;rask-multi-range-selector<br>
                                                        &nbsp;&nbsp;itemsTitle="Hela listan"<br>
                                                        &nbsp;&nbsp;valueTitle="Valda värden"<br>
                                                        &nbsp;&nbsp;[value]="multiRangeSelectValue"<br>
                                                        &nbsp;&nbsp;[items]="multiRangeSelectItems"<br>
                                                        &nbsp;&nbsp;[orderItemsBy]="multiRangeSelectOrderBy"<br>
                                                        &nbsp;&nbsp;[orderValueBy]="multiRangeSelectOrderBy"<br>
                                                        &nbsp;&nbsp;[viewFormatter]="multiRangeSelectViewFormatter"<br>
                                                        &nbsp;&nbsp;size="5" &gt; &lt;/rask-multi-range-select&gt;
                                                        <br>
                                                        </code>
            <rask-multi-range-select
                itemsTitle="Hela listan"
                valueTitle="Valda värden"
                [value]="multiRangeSelectValue"
                [items]="multiRangeSelectItems"
                [orderItemsBy]="multiRangeSelectOrderBy"
                [orderValueBy]="multiRangeSelectOrderBy"
                [viewFormatter]="multiRangeSelectViewFormatter"
                [size]="5">
            </rask-multi-range-select>
        </div>

        <div class="example" id="rask-tag">
            <a id="rasktag"></a>
            <rask-header size="4" noPadding>Rask tag</rask-header>
            <p>
                <strong>label</strong> Titel över selectorn <br>
                <strong>selected</strong> En array av taggar som ska visas<br>
                <strong>clearAllTooltipText</strong> Tooltip text som visas när man hovrar över x<br>
                <strong>rule</strong> Valideringsregler<br>
            </p>
            <code>
                                                          &lt;rask-tag label=&quot;Tag&quot; [selected]=&quot;['V&auml;rde 1']&quot; clearAllText=&quot;Ta bort
                                                          tag&quot;&gt;
                                                        </code>
            <rask-tag class="col-3" label="Tag" [selected]="['En tag', 'Två taggar']" clearAllTooltipText="Ta bort tag">
            </rask-tag>
            <rask-tag class="col-3" label="Tag - disabled" [selected]="['En tag', 'Två taggar']"
                clearAllTooltipText="Ta bort tag" [disabled]="true">
            </rask-tag>

        </div>

        <div class="example" id="rask-slider">
            <a id="raskslider"></a>
            <rask-header size="4" noPadding>Rask slider</rask-header>
            <p>
                Första slidern är "one way"-bunden och den andra är "two way"-bunden och de delar modell.
                Innebär att ändringar i den andra slidern får omedelbar effekt på den första, medans ändringar i den
                första inte omedelbart syns i den andra.
                Ändringar i den första loggas dock alltid i "event-handlern" för valueChange (log($event)).
            </p>
            <p>
                <strong>formControlName</strong> styr vilken property i formgroup modellen som fältet ska bindas mot<br>
                <strong>[ngModel]</strong> * (Utanför formulär) Initialt värde (envägsdatabindning)<br>
                <strong>[(ngModel)]</strong> * (Utanför formulär) modell (tvåvägsdatabidning)<br>
                <strong>min</strong> Minsta värde på skalan (default 0)<br>
                <strong>max</strong> Största värde på skalan (default 1)<br>
                <strong>step</strong> Hur stort ett skalsteg är (default 0.1)<br>
                <strong>[useLabels]</strong> Om etiketter ska visas längs linjen (default false)<br>
                <strong>[viewFormatter]</strong> Funktion för att formatera värde för visning<br>
                <strong>(change)</strong> Event med senaste värde vid förändring<br>
            </p>
            <code>
                                                          &lt;rask-slider class="col-6" formControlName="slider" [(ngModel)]="model.slider" [min]="0" [max]="1"
                                                          [step]="0.01"<br>
                                                          &nbsp;(change)="log($event)" [useLabels]="true" [viewFormatter]="sliderOpacityValueFormatter"&gt;<br>
                                                          &lt;/rask-slider&gt;<br>
                                                          &lt;rask-slider class="col-6" [(ngModel)]="model.slider" [min]="0" [max]="1" [step]="0.01"<br>
                                                          &nbsp;[useLabels]="true" [viewFormatter]="sliderValueFormatter"&gt;<br>
                                                          &lt;/rask-slider&gt;<br>
                                                          &lt;rask-slider class="col-6" [ngModel]="model.slider" [min]="0" [max]="1" [step]="0.01"<br>
                                                          &nbsp;[useLabels]="true" [viewFormatter]="sliderValueFormatter" (change)="log($event)"&gt;<br>
                                                          &lt;/rask-slider&gt;<br>
                                                        </code>
            <rask-slider class="col-12" formControlName="slider" [(ngModel)]="model.slider" [min]="0" [max]="1"
                [step]="0.01"
                (change)="log($event)" [useLabels]="true" [viewFormatter]="sliderValueFormatter">
            </rask-slider>
        </div>
        <rask-showroom-validation id="rask-validation" class="example"></rask-showroom-validation>

        <rask-showroom-rask-button id="rask-button" class="example"></rask-showroom-rask-button>

        <div class="example" id="rask-submit-button">
            <a id="rasksubmitbutton"></a>
            <rask-header size="4" noPadding>Rask submit knapp</rask-header>
            <p>
                Childkomponent av rask-button, som default har type = 'submit'.
                Används i formulär som submitknapp om formuläret har bunden ngSubmit.
                Läggs knappen utanför formuläret kan knappen bindas mot formulärets id med det ärvda attributet form,
                form="myFormId"
                detta gör också att vi kan submitta formulär med 'Enter'.
            </p>
            <code>
                                                          &lt;form&nbsp;ngSubmit="spara()"&gt;<br>
                                                          &nbsp;&nbsp;&lt;rask-submit-button&gt;Spara&lt;/rask-submit-button&gt;<br>
                                                          &lt;/form&gt;<br><br>

                                                          &lt;form&nbsp;id="myForm"&nbsp;ngSubmit="spara()"&gt;<br>
                                                          &lt;/form&gt;<br><br>

                                                          &nbsp;&nbsp;<br>
                                                          &lt;rask-submit-button&nbsp;form="myForm"&gt;Spara&lt;/rask-submit-button&gt;<br>
                                                        </code>

        </div>

        <div class="example" id="rask-save-button">
            <a id="rasksavebutton"></a>
            <rask-header size="4" noPadding>Rask save knapp</rask-header>
            <p>
                <strong>color</strong> utseende på knappen, default satt till 'primary'
                <strong>type</strong> sätts till 'submit' om komponenten ligger i ett formulär<br>
                <strong>form</strong> om utan formulär anges form.id här, komponenten defaultar då till type 'submit'
                och 'Enter' kan användas för att submitta<br>
                <strong>click</strong> metod att binda mot vid click<br>
                <strong>disable</strong> disable <br>
                <strong>tooltipText</strong> override på default tooltiptext<br>
                Används som primär sparaknapp.
                Följande attribut har redan defaultvärden vi vill ha för alla primära sparaknappar:
                aid, type, color, label, tooltip, ctrl+s,
                <br>
                <br>
                Anges något content ersätter det default-content som är 'Spara'
            </p>
            <code>
                                                              &lt;rask-save-button (click)="log('pling')"&gt;&lt;/rask-button&gt;<br>

                                                              &lt;rask-save-button&nbsp;(click)="log('pling')"&gt;Spara&lt;/rask-save-button&gt;<br>

                                                              &lt;form&nbsp;ngSubmit="spara()"&gt;<br>
                                                              &nbsp;&nbsp;&lt;rask-save-button&gt;&lt;/rask-save-button&gt;<br>
                                                              &lt;/form&gt;<br><br>

                                                              &lt;form&nbsp;id="myForm"&nbsp;ngSubmit="spara()"&gt;<br>
                                                              &lt;/form&gt;<br><br>

                                                              &nbsp;&nbsp;<br>
                                                              &lt;rask-save-button&nbsp;form="myForm"&gt;&lt;/rask-save-button&gt;<br>
                                                            </code>
            <form id="myFormId" (ngSubmit)="log('pling formulär')">
                <rask-input value="Tryck enter här"></rask-input>
            </form>
            <rask-save-button form="myFormId" [disabled]="false">Spara formulär</rask-save-button>
            <br>
            <br>
            <rask-save-button (click)="log('spara')"></rask-save-button>

        </div>

        <div class="example" id="rask-span">
            <a id="raskspan"></a>
            <rask-header size="4" noPadding>Rask span</rask-header>
            <p>
                <strong>size</strong> Översätts till col-lg-&#123;size&#125; (default 1)<br>
            </p>
            <code>
                                                                  &lt;rask-span size=&quot;3&quot; &lt;/rask-span&gt;
                                                                </code>
            <rask-span size="3">Lite text</rask-span>
        </div>

        <div class="example" id="rask-label">
            <a id="rasklabel"></a>
            <rask-header size="4" noPadding>Rask label</rask-header>
            <p>
                <strong>size</strong> Översätts till col-lg-&#123;size&#125; (default 1)<br>
            </p>
            <code>
                                                                  &lt;rask-label size=&quot;3&quot;&gt;&lt;/rask-label&gt;
                                                                </code>
            <rask-label size="3">Lite text</rask-label>
        </div>

        <div class="example" id="rask-text-expander">
            <a id="rasktextexpander"></a>
            <rask-header size="4" noPadding>Rask text expander</rask-header>
            <p>
                <strong>text</strong> Text som ska visas<br>
                <strong>rows</strong> Antal rader som ska visas i infällt läge<br>
            </p>
            <code>
                                                                  &lt;rask-text-expander [text]=&quot;textExpanderText&quot;
                                                                  rows=&quot;2&quot;&gt;&lt;/rask-text-expander&gt;
                                                                </code>
            <rask-text-expander [text]="textExpanderText" [rows]="2"></rask-text-expander>
        </div>

        <div class="example" id="rask-action-button">
            <a id="raskactionbutton"></a>
            <rask-header size="4" noPadding>Rask action-button</rask-header>
            <p>
                <strong>icon</strong> Ikon<br>
            </p>
            Rask-action-button ska användas i en rask-header för olika actions som är relaterade till innehållet, tex
            "lägg till"
            <code>
                                                                  &lt;rask-header size=&quot;3&quot; underline&gt;<br>
                                                                  &nbsp;&nbsp;Titel<br>
                                                                  &nbsp;&nbsp;&lt;rask-action-button (click)=&quot;log('pling')&quot; icon=&quot;fa
                                                                  fa-plus&quot;&gt;Header action&lt;/rask-action-button&gt;<br>
                                                                  &lt;/rask-header&gt;
                                                                </code>
            <rask-header size="3" underline>
                Titel
                <rask-action-button (click)="log('pling')" icon="fas fa-plus">Header action</rask-action-button>
            </rask-header>

            <rask-header size="3" underline>
                Titel - action button align left
                <rask-action-button [options]="buttonOptions" (optionSelected)="buttonSelect($event)" alignment="left"
                    icon="fas fa-plus">Action</rask-action-button>
            </rask-header>

            <rask-header size="3" underline>
                Titel - action button align right
                <rask-action-button [options]="buttonOptions" (optionSelected)="buttonSelect($event)" alignment="right"
                    icon="fas fa-plus">Action</rask-action-button>
            </rask-header>

            <br><br>
            <p>
                <strong>disabled</strong> Gör ikonen och text utgråad samt förhindrar klick på knappen.<br>
            </p>
            Om t.e.x. behörighet saknas till knappen läggs attributet disabled på rask-action-button
            <code>
                                                                  &lt;rask-action-button (click)=&quot;log('pling')&quot; icon=&quot;far fa-trash-alt&quot;
                                                                  disabled&gt;&lt;/rask-action-button&gt;
                                                                </code>
            <rask-header size="3" underline>
                Titel
                <rask-action-button (click)="log('pling')" icon="fas fa-plus" disabled>Header action
                </rask-action-button>
            </rask-header>

            <br><br>
            <p>
                <strong>negative</strong> Gör ikonen röd.<br>
            </p>
            Vissa ikoner(t.e.x. soptunna) som används i rask-aktion-button skall vara röda då används attributet
            "negative" för att byta färg.
            <code>
                                                                  &lt;rask-action-button (click)=&quot;log('pling')&quot; icon=&quot;far fa-trash-alt&quot;
                                                                  negative&gt;&lt;/rask-action-button&gt;
                                                                </code>
            <rask-action-button (click)="log('pling')" icon="far fa-trash-alt" negative></rask-action-button>
        </div>

        <div class="example" id="rask-menu-button">
            <a id="raskmenubutton"></a>
            <rask-header size="4" noPadding>rask-menu-button (template)</rask-header>
            <p>
                <strong>template</strong> TemplateRef<br>
                <strong>label*</strong> string<br>
                <strong>icon*</strong> string (font awesome)<br>
                <strong>alignment</strong> "left" | "right"<br>
                <i>*) optional.</i><br>
            </p>
            Knapp med dynamiskt innehåll som visas i en template vid toggle
            <code>
                                                                  &lt;rask-menu-button [template]=&quot;tpl&quot; icon=&quot;fa fa-bars&quot; &gt;<br>
                                                                  &lt;/rask-menu-button&gt;<br>
                                                                  <br>
                                                                    &lt;ng-template #tpl&gt;<br>
                                                                    &nbsp;... Some content<br>
                                                                    &lt;/ng-template&gt;<br>
                                                                  </code>
            <rask-menu-button [template]="tpl" alignment="left">
            </rask-menu-button>

            <ng-template #tpl>
                <div style="width: 190px;">
                    <rask-action-button
                        icon="fas fa-sync-alt"
                        (click)="log('pling')">Alternativ 1</rask-action-button><br />
                    <rask-action-button
                        icon="fas fa-sync-alt"
                        (click)="log('pling')">Alternativ 2</rask-action-button>
                </div>
            </ng-template>
        </div>

        <div class="example" id="raskmenubutton-options">
            <a id="raskmenubutton-options"></a>
            <rask-header size="4" noPadding>rask-menu-button (options)</rask-header>
            Knapp med alternativ. Rask-menu-button med key/value options och callback "selected" istället för template.
            <p>
                <strong>alignment</strong> "left" | "right"<br>
                <strong>label*</strong> string<br>
                <strong>icon*</strong> string (font awesome)<br>
                <strong>options</strong> IOption[]<br>
                <strong>selected</strong> <i>out</i> (IOption)<br>
                <i>*) optional.</i><br>
            </p>
            <code>
                                                                    &lt;rask-menu-button icon=&quot;fa-solid fa-chevron-down&quot; label=&quot;Valj djur&quot;<br> [options]=&quot;[option1, option2, option3 ...]&quot;<br> (selected)=&quot;callback($event)&quot; &gt;<br>
                                                                    &lt;/rask-button-select&gt;<br>
                                                                    <br>
                                                                    </code>
            <rask-menu-button label="Välj djur" alignment="left" [options]="buttonOptions"
                (selected)="buttonSelect($event)">
            </rask-menu-button>
            <br>
            <br>
            <b>{{ buttonOptionSelected | json }}</b>
            <br>
        </div>

        <div class="example" id="rask-list">
            <a id="rasklist"></a>
            <rask-header size="4" noPadding>Rask list</rask-header>
            <p>
                <strong>data</strong> Raderna / modellerna som ska hanteras i tabellen<br>
                <strong>openFn</strong> Funktion att anrop när man klickar på en rad<br>
                <strong>useClientFilter</strong> Visar sök ruta ovanför lista, som utför klient side sök på
                resultatet<br>
                <strong>clientFilterResultText</strong> text till sökresultatet<br>
            </p>

            Tabellen kan visas med endast data kopplat, då kommer namnet hämtas från fälten. Ordning blir efter
            ordningen i objektet<br>
            <br>
            <code>
                                                                              &lt;rask-list [data]=&quot;tableData&quot; &gt;&lt;/rask-list&gt;<br>
                                                                              <br>
                                                                                <br>
                                                                                  tableData = {{ clone(tableData) | json}}
                                                                                </code>
            <rask-list [data]="tableData" [useClientFilter]="true" clientFilterResultText="st exempel visas">
                <rask-list-column header="Namn" field="namn"></rask-list-column>
                <rask-list-column header="Value" field="value"></rask-list-column>
                <rask-list-column header="Other" field="other"></rask-list-column>
            </rask-list>
            <rask-button color="tertiary" (click)="getSortedData()">Hämta sorterad data</rask-button><br>
            Fältet columns specar beteende och utseende.<br>
            <br>
            <strong><u>rask-list-column</u></strong><br>
            <strong>header</strong> rubrik på columnen <br>
            <strong>field</strong> namnet/nyckeln på fältet som ska kopplas <br>
            <strong>sortable</strong> ska fältet vara sorterbart<br>
            <strong>width</strong> bredd på kolumn kan anges i % eller px <br>
            <strong>nowrap</strong> om sant klipps texten i kolumnen<br>
            <strong>rowSelectable</strong> om sant checkboxar läggs till för att välja raden. Använd sedan ViewChild för
            att nå metoden getSelectedRows för att veta vilka som är valda.<br>
            <rask-list #listWithCheckboxesInstance [rowSelectable]="true" [data]="tableData">
                <rask-list-column header="Namn" field="namn" [sortable]="true">
                    <ng-template let-value>
                        <a href="http:\\www.di.se" target="_blank">{{value}}</a>
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Value" field="value" [sortable]="true"></rask-list-column>
                <rask-list-column header="Other" field="other" width="100px" [nowrap]="true">
                    <ng-template let-row="row">
                        {{row.other}} + {{row.namn}}
                    </ng-template>
                    <ng-template #headerTemplate1>
                        <b>Egen rubrik</b>
                    </ng-template>
                </rask-list-column>
            </rask-list>
            <br>

            <strong><u>Rask list selected items</u></strong><br>
            Visar upp en knapp som kan presentera val gjorda i rask listan<br>
            <strong>Data</strong> valda rader som kan hämtas från tabellen med metoden getSelectedRows<br>
            <strong>removeFromSelection</strong> Output event som signalerar att den valda raden skall avmarkeras i
            tabellen<br>
            <rask-list #listWithCheckboxesInstanceAndSelectPopover [rowSelectable]="true" [data]="tableData">
                <rask-list-column header="Namn" field="namn" [sortable]="true">
                    <ng-template let-value>
                        <a href="http:\\www.di.se" target="_blank">{{value}}</a>
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Value" field="value" [sortable]="true"></rask-list-column>
                <rask-list-column header="Other" field="other" width="100px" [nowrap]="true">
                    <ng-template let-row="row">
                        {{row.other}} + {{row.namn}}
                    </ng-template>
                    <ng-template #headerTemplate2>
                        <b>Egen rubrik</b>
                    </ng-template>
                </rask-list-column>
            </rask-list>
            <rask-list-selected-items class="rask-list-selected-items" [data]="getSelectedListItems()"
                (removeFromSelection)="removeFromSelection($event)"></rask-list-selected-items><br>
        </div>

        <div class="example" id="rask-div-list">
            <a id="raskdivlist"></a>
            <rask-header size="4" noPadding>Rask div list</rask-header>
            <p>
                <strong>data</strong> Raderna / modellerna som ska hanteras i tabellen<br>
                <strong>rowDrag</strong> Möjlighet att sortera rader med drag and drop<br>
                <strong>openFn</strong> Funktion att anrop när man klickar på en rad<br>
            </p>

            Tabellen kan visas med endast data kopplat, då kommer namnet hämtas från fälten. Ordning blir efter
            ordningen i objektet<br>
            <br>
            <code>
                                                                                        &lt;rask-list [data]=&quot;tableData&quot; [rowDrag]=&quot;true&quot;&gt;&lt;/rask-list&gt;<br>
                                                                                        <br>
                                                                                          <br>
                                                                                            tableData = {{ clone(tableData) | json}}
                                                                                          </code>
            <rask-div-list #listInstance [data]="tableData" [rowDrag]="true">
                <rask-list-column header="Namn" field="namn"></rask-list-column>
                <rask-list-column header="Value" field="value"></rask-list-column>
                <rask-list-column header="Other" field="other"></rask-list-column>
            </rask-div-list>
            <rask-button color="tertiary" (click)="getSortedData()">Hämta sorterad data</rask-button><br>
            Fältet columns specar beteende och utseende.<br>
            <br>
            <strong><u>rask-list-column</u></strong><br>
            <strong>header</strong> rubrik på columnen <br>
            <strong>field</strong> namnet/nyckeln på fältet som ska kopplas <br>
            <strong>sortable</strong> ska fältet vara sorterbart<br>
            <strong>width</strong> bredd på kolumn kan anges i % eller px <br>
            <strong>nowrap</strong> om sant klipps texten i kolumnen<br>
            <rask-div-list [data]="tableData" [rowDrag]="false">
                <rask-list-column header="Namn" field="namn" [sortable]="true">
                    <ng-template let-value>
                        <a href="http:\\www.di.se" target="_blank">{{value}}</a>
                    </ng-template>
                </rask-list-column>
                <rask-list-column header="Value" field="value" [sortable]="true"></rask-list-column>
                <rask-list-column header="Other" field="other" width="200px" [nowrap]="true">
                    <ng-template let-row="row">
                        {{row.other}} + {{row.namn}}
                    </ng-template>
                </rask-list-column>
            </rask-div-list>
        </div>

        <div class="example" id="rask-table">
            <a id="rasktable"></a>
            <rask-header size="4" noPadding>Rask table</rask-header>
            <p>
                <strong>data</strong> Raderna / modellerna som ska hanteras i tabellen<br>
                <strong>columns</strong> En lista med RaskColumns för att styra beteende för kolumnerna<br>
                <strong>columnDefs</strong> En lista med ag-grid kolumner ifall man vill göra mer än vanliga kolumnerna
                erbjuder (endast i nödfall)<br>
                <strong>editable</strong> Om man inte anger några kolumnspecifikationer går det att toggla editläge med
                denna<br>
                <strong>showColumns</strong> Toggla synbarheten för kolumnheaders<br>
            </p>

            Tabellen kan visas med endast data kopplat, då kommer namnet hämtas från fälten. Ordning blir efter
            ordningen i objektet<br>
            <code>
                                                                                              &lt;rask-table [data]=&quot;tableData&quot;&gt;&lt;/rask-table&gt;<br>
                                                                                              <br>
                                                                                                <br>
                                                                                                  tableData = {{ clone(raskTableData) | json}}
                                                                                                </code>
            <rask-table [data]="tableData" [columns]="tableColumns"></rask-table>
            Fältet columns specar beteende och utseende.<br>
            <br>
            <strong><u>RaskColumn</u></strong><br>
            <strong>field</strong> namnet/nyckeln på fältet som ska kopplas <br>
            <strong>type</strong> Vilket sätt / vilken komponent värdet ska visas med <br>
            <strong>field</strong> namnet/nyckeln på fältet som ska kopplas <br>
            <strong>rule</strong> Valideringsregel <br>
            <strong>values</strong> värden till selector / treeselector typen <br>
            <strong>sortable</strong> ska fältet vara sorterbart <br>
            <strong>initialWidth</strong> standardbredd i pixlar <br>
            <strong>maxWidth</strong> maxbredd i pixlar <br>
            <strong>minWidth</strong> minimumbredd i pixlar <br>
            <strong>text</strong> text till ev knapp <br>
            <strong>onClick</strong> click-callback <br>
            <strong>footerText</strong> Text till summeringsrad istället för värde<br>
            <strong>footerAgg</strong> Summeringsfunktion till footerrad <br>
            <strong>headerParams</strong> Om det ska visas en ikon anges här <i>iconClass</i> och eventuellt
            <i>popoverMessage</i> <br>
            <strong>resizable</strong> Om kolumnens storlek ska kunna justeras (default false)<br>
            <br>
            <br>
            <code>
                &lt;rask-table [data]=&quot;raskTableData&quot; [columns]=&quot;raskTableColumns&quot;&gt;&lt;/rask-table&gt;
                <br>
                <br>
                raskTableData = {{ clone(tableData) | json }}<br>
                <br>
                raskTableColumns = [<br>
                {{ clone(columnsCloned[0]) | json}}, <br>
                {{ clone(columnsCloned[1]) | json}}, <br>
                {{ clone(columnsCloned[2]) | json}}] <br>
            </code>
            <rask-table #tableInstance [data]="raskTableData" [columns]="raskTableColumns"
                (rowDragEnd)="onRowDragEnd($event)"></rask-table>
        </div>

        <div class="example" id="rask-hot-doc">
            <a id="rasktable"></a>
            <rask-header size="4" noPadding>Rask HotDoc</rask-header>
            <p>

            </p>


            <code>

                                                                                                            </code>
            <rask-hot-doc
                [hotDoc]="hotDocExample">
            </rask-hot-doc>
        </div>

        <div class="example" id="rask-pipe-string-format">
            <a id="raskpipestringformat"></a>
            <rask-header size="4" noPadding>Rask Pipe - String Format</rask-header>
            <p>
                Fungerar på ungefär samma sätt som String.Format i C#.<br />
                Bra att använda när man ska översätta texter med variabler på specifika positioner.<br />
                Används exempelvis i rask-textarea för att producera texten "x tecken kvar", där x är en variabel men
                även hela frasen är en översättningsvariabel
            </p>
            <strong>TypeScript</strong>
            <!-- Här använder jag angular för att parsea koden som en sträng, istället för att behöva göra om det till html-encoding vilket inte fungerar så bra när det är TypeScript med curly braces-->
            <code>
                {{ 'pipeSF = {' }}<br />
                {{ '&nbsp;&nbsp;pirateSong : "{1} gastar på en {2} mans {0}",' }}<br />
                {{ '&nbsp;&nbsp;trans15 : 15,' }}<br />
                {{ '&nbsp;&nbsp;transDeath : "död"' }}<br />
                {{ '};' }}
            </code>
            <strong>Template</strong>
            <code ngNonBindable>
                {{ pipeSF.pirateSong | raskStringFormat :"kista":pipeSF.trans15:pipeSF.transDeath }}
            </code>
            <strong>Resultat</strong>
            <div>
                {{ pipeSF.pirateSong | raskStringFormat :"kista":pipeSF.trans15:pipeSF.transDeath }}
            </div>
        </div>
        <div class="example" id="rask-pipe-linkify">
            <a id="raskpipelinkify"></a>
            <rask-header size="4" noPadding>Rask Pipe - Linkify</rask-header>
            <p>
                Pipe f&ouml;r att g&ouml;ra om urler i text till ankartaggar &lt;a href=&quot;&quot;
                target=&quot;_blank&quot;&gt;&lt;/a&gt;.
                Och epostadresser till mailto l&auml;nkar &lt;a href=&quot;mailto:&quot;&gt;&lt;/a&gt;
            </p>
            <strong>TypeScript</strong>
            <!-- Här använder jag angular för att parsea koden som en sträng, istället för att behöva göra om det till html-encoding vilket inte fungerar så bra när det är TypeScript med curly braces-->
            <code>
                                                                                                              linkifyText = "läs mer på http://www.di.se.";<br />
                                                                                                              linkifyEmailText = "Skicka mail till info&#64;nomail.se";
                                                                                                            </code>
            <strong>Template</strong>
            <code ngNonBindable>
                                                                                                              &lt;div [innerHTML]=&quot;linkifyText | raskLinkifyFormat: linkifyText&quot;&gt;&lt;/div&gt;<br />
                                                                                                              &lt;div [innerHTML]=&quot;linkifyEmailText | raskLinkifyFormat: linkifyEmailText&quot;&gt;&lt;/div&gt;
                                                                                                            </code>
            <strong>Resultat</strong>
            <div>
                <div [innerHTML]="linkifyText | raskLinkifyFormat"></div>
                <div [innerHTML]="linkifyEmailText | raskLinkifyFormat"></div>
            </div>
        </div>
        <div class="example" id="rask-pipe-newlines">
            <a id="raskpipenewlines"></a>
            <rask-header size="4" noPadding>Rask Pipe - Newlines</rask-header>
            <p>
                Ers&auml;tter alla \r\n och \n med &lt;br/&gt;
            </p>
            <strong>Template</strong>
            <code ngNonBindable>
                                                                                                              {{ '\n\r\n\n' | raskNewlines }}
                                                                                                            </code>
            <strong>Resultat markup</strong>
            <div>
                {{ '\n\r\n\n' | raskNewlines }}
            </div>
            <strong>Resultat innerHTML</strong>
            <div [innerHTML]="'\n\r\n\n' | raskNewlines ">
            </div>
        </div>

        <div class="example" id="rask-pipe-highlight">
            <a id="raskpipehighlight"></a>
            <rask-header size="4" noPadding>Rask Pipe - Highlight</rask-header>
            <p>
                Omringar alla f&ouml;rekomster av ett ord med &lt;mark&gt;ord&lt;/mark&gt;
            </p>
            <strong>Template</strong>
            <code ngNonBindable>
                                                                                                              {{ 'Detta är en exempelfras som används på sidan för exempel' | raskHighlight:'exempel' }}
                                                                                                            </code>
            <strong>Resultat markup</strong>
            <div>
                {{ 'Detta är en exempelfras som används på sidan för exempel' | raskHighlight:'exempel' }}
            </div>
            <strong>Resultat innerHTML</strong>
            <div [innerHTML]="'Detta är en exempelfras som används på sidan för exempel' | raskHighlight:'exempel'">
            </div>
        </div>

        <div class="example" id="rask-pipe-filter">
            <a id="raskpipefilter"></a>
            <rask-header size="4" noPadding>Rask Pipe - Filter</rask-header>
            <p>
                Filtrerar fram alla objekt i en lista där minst en av egenskaperna eller child-egenskaperna innehåller
                den önskade frasen<br /><br />
                Exempel: En lista med fyra objekt. Vissa av objekten består av en eller flera child-objekt. Filtret
                filtrerar fram alla objekt där något av objektens egenskaper matchar "sveaskog", vilket är obj1, obj3,
                obj4.
            </p>
            <strong>TypeScript</strong>
            <code>
                                                                                                              <pre>{{pipeFilter | json}}</pre>
                                                                                                            </code>
            <strong>Template</strong>
            <code ngNonBindable>
                                                                                                              &lt;div *ngFor=&quot;let item of pipeFilter.objects | raskFilter: pipeFilter.filterName&quot;&gt;<br />
                                                                                                              &nbsp;&nbsp;&lt;pre&gt;{{item | json}}&lt;/pre&gt;<br />
                                                                                                              &lt;/div&gt;
                                                                                                            </code>
            <strong>Resultat</strong>
            <div>
                @for (item of pipeFilter.objects | raskFilter: pipeFilter.filterName; track item) {
                <div>
                    <pre>{{item | json}}</pre>
                </div>
                }
            </div>
        </div>
    </div>
</form>